'use es6';

export const IFRAME_STATE_SYNCED = 'IFRAME_STATE_SYNCED';